import React from 'react';
import { Modal } from 'antd';
import { Button } from '@/components/Button';
import styles from './HtsQuestionnaire.module.scss';

interface HtsSubmitModalProps {
  total: number;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const HtsSubmitModal: React.FC<HtsSubmitModalProps> = ({ total, onCancel, onConfirm, loading }) => (
  <Modal open closable={false} maskClosable={false} footer={null} width={440} centered>
    <h3 className={styles.confirmTitle}>Submit your responses?</h3>
    <p className={styles.confirmBody}>
      All {total} questions are answered. Once submitted, this questionnaire is locked and reviewed
      confidentially by your care team.
    </p>
    <div className={styles.confirmActions}>
      <Button appearance="outline" onClick={onCancel} disabled={loading}>Review answers</Button>
      <Button appearance="solid" onClick={onConfirm} loading={loading}>Submit</Button>
    </div>
  </Modal>
);
